import { render, staticRenderFns } from "./ExtendAdd.vue?vue&type=template&id=6fd7046e&scoped=true"
import script from "./ExtendAdd.vue?vue&type=script&lang=js"
export * from "./ExtendAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7046e",
  null
  
)

export default component.exports